
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import ContactSection from "@/components/ContactSection";
import Seo from "@/components/Seo";
import {
  buildBreadcrumbJsonLd,
  buildCanonicalUrl,
  buildWebPageJsonLd,
  organizationJsonLd,
  websiteJsonLd,
} from "@/lib/seo";

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-white">
      <Seo
        title="Contact Travel Wings Global | Forex & Travel Assistance"
        description="Reach Travel Wings Global for forex, travel packages, visas, and support. Call or message our team for quick assistance."
        path="/contact"
        structuredData={[
          organizationJsonLd,
          websiteJsonLd,
          buildWebPageJsonLd({
            name: "Contact Travel Wings Global | Forex & Travel Assistance",
            description:
              "Contact Travel Wings Global for forex services, travel packages, visa support, and insurance.",
            url: buildCanonicalUrl("/contact"),
            type: "ContactPage",
          }),
          buildBreadcrumbJsonLd([
            { name: "Home", url: buildCanonicalUrl("/") },
            { name: "Contact", url: buildCanonicalUrl("/contact") },
          ]),
        ]}
      />
      <Navigation />
      
      {/* Hero Section */}
      <section className="pt-24 pb-16 bg-gradient-to-b from-orange-50 to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
            Contact <span className="text-orange-600">Us</span>
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Ready to start your journey? Contact us for personalized travel and forex solutions
          </p>
        </div>
      </section>

      {/* Contact Form Section */}
      <ContactSection />

      <Footer />
    </div>
  );
}